// source: wisetime/user/preferences/v4/preferences.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest', null, global);
goog.exportSymbol('proto.wisetime.user.preferences.v4.RecentNarrative', null, global);
goog.exportSymbol('proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest', null, global);
goog.exportSymbol('proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse', null, global);
goog.exportSymbol('proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest', null, global);
goog.exportSymbol('proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.displayName = 'proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.displayName = 'proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.displayName = 'proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.displayName = 'proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.preferences.v4.RecentNarrative = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.preferences.v4.RecentNarrative, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.preferences.v4.RecentNarrative.displayName = 'proto.wisetime.user.preferences.v4.RecentNarrative';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.displayName = 'proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    searchTerm: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest}
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest;
  return proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest}
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchTerm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSearchTerm();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 page_size = 1;
 * @return {number}
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest} returns this
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string search_term = 2;
 * @return {string}
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.prototype.getSearchTerm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest} returns this
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsRequest.prototype.setSearchTerm = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    manualTimeCommentsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse}
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse;
  return proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse}
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addManualTimeComments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManualTimeCommentsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string manual_time_comments = 1;
 * @return {!Array<string>}
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.prototype.getManualTimeCommentsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse} returns this
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.prototype.setManualTimeCommentsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse} returns this
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.prototype.addManualTimeComments = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse} returns this
 */
proto.wisetime.user.preferences.v4.SearchRecentManualTimeCommentsResponse.prototype.clearManualTimeCommentsList = function() {
  return this.setManualTimeCommentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    searchTerm: jspb.Message.getFieldWithDefault(msg, 3, ""),
    timeGroupId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest;
  return proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchTerm(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getSearchTerm();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest} returns this
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 page_size = 2;
 * @return {number}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest} returns this
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string search_term = 3;
 * @return {string}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.prototype.getSearchTerm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest} returns this
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.prototype.setSearchTerm = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string time_group_id = 5;
 * @return {string}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.prototype.getTimeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest} returns this
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.prototype.setTimeGroupId = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest} returns this
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.prototype.clearTimeGroupId = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesRequest.prototype.hasTimeGroupId = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    narrativesList: jspb.Message.toObjectList(msg.getNarrativesList(),
    proto.wisetime.user.preferences.v4.RecentNarrative.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse;
  return proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.preferences.v4.RecentNarrative;
      reader.readMessage(value,proto.wisetime.user.preferences.v4.RecentNarrative.deserializeBinaryFromReader);
      msg.addNarratives(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNarrativesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.user.preferences.v4.RecentNarrative.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RecentNarrative narratives = 1;
 * @return {!Array<!proto.wisetime.user.preferences.v4.RecentNarrative>}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.prototype.getNarrativesList = function() {
  return /** @type{!Array<!proto.wisetime.user.preferences.v4.RecentNarrative>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.user.preferences.v4.RecentNarrative, 1));
};


/**
 * @param {!Array<!proto.wisetime.user.preferences.v4.RecentNarrative>} value
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse} returns this
*/
proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.prototype.setNarrativesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.user.preferences.v4.RecentNarrative=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.user.preferences.v4.RecentNarrative}
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.prototype.addNarratives = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.user.preferences.v4.RecentNarrative, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse} returns this
 */
proto.wisetime.user.preferences.v4.SearchRecentNarrativesResponse.prototype.clearNarrativesList = function() {
  return this.setNarrativesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.preferences.v4.RecentNarrative.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.preferences.v4.RecentNarrative.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.preferences.v4.RecentNarrative} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.preferences.v4.RecentNarrative.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    narrative: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.preferences.v4.RecentNarrative}
 */
proto.wisetime.user.preferences.v4.RecentNarrative.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.preferences.v4.RecentNarrative;
  return proto.wisetime.user.preferences.v4.RecentNarrative.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.preferences.v4.RecentNarrative} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.preferences.v4.RecentNarrative}
 */
proto.wisetime.user.preferences.v4.RecentNarrative.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNarrative(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.preferences.v4.RecentNarrative.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.preferences.v4.RecentNarrative.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.preferences.v4.RecentNarrative} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.preferences.v4.RecentNarrative.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNarrative();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.wisetime.user.preferences.v4.RecentNarrative.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.preferences.v4.RecentNarrative} returns this
 */
proto.wisetime.user.preferences.v4.RecentNarrative.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string narrative = 2;
 * @return {string}
 */
proto.wisetime.user.preferences.v4.RecentNarrative.prototype.getNarrative = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.user.preferences.v4.RecentNarrative} returns this
 */
proto.wisetime.user.preferences.v4.RecentNarrative.prototype.setNarrative = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    recentNarrative: (f = msg.getRecentNarrative()) && proto.wisetime.user.preferences.v4.RecentNarrative.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest}
 */
proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest;
  return proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest}
 */
proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.user.preferences.v4.RecentNarrative;
      reader.readMessage(value,proto.wisetime.user.preferences.v4.RecentNarrative.deserializeBinaryFromReader);
      msg.setRecentNarrative(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecentNarrative();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wisetime.user.preferences.v4.RecentNarrative.serializeBinaryToWriter
    );
  }
};


/**
 * optional RecentNarrative recent_narrative = 1;
 * @return {?proto.wisetime.user.preferences.v4.RecentNarrative}
 */
proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.prototype.getRecentNarrative = function() {
  return /** @type{?proto.wisetime.user.preferences.v4.RecentNarrative} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.user.preferences.v4.RecentNarrative, 1));
};


/**
 * @param {?proto.wisetime.user.preferences.v4.RecentNarrative|undefined} value
 * @return {!proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest} returns this
*/
proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.prototype.setRecentNarrative = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest} returns this
 */
proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.prototype.clearRecentNarrative = function() {
  return this.setRecentNarrative(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.user.preferences.v4.DeleteRecentNarrativeRequest.prototype.hasRecentNarrative = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.wisetime.user.preferences.v4);
